import { render, staticRenderFns } from "./VideoSelector.vue?vue&type=template&id=6a3d8f8c&scoped=true&"
import script from "./VideoSelector.vue?vue&type=script&lang=js&"
export * from "./VideoSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d8f8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3d8f8c')) {
      api.createRecord('6a3d8f8c', component.options)
    } else {
      api.reload('6a3d8f8c', component.options)
    }
    module.hot.accept("./VideoSelector.vue?vue&type=template&id=6a3d8f8c&scoped=true&", function () {
      api.rerender('6a3d8f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Video/Includes/VideoSelector.vue"
export default component.exports